// AiModelPicker.tsx — widget del step 'ai-model' (solo Business eligiendo AI/Mix).
// Qué hace: grilla de modelos KIE + opción "mix all models".
// Qué exporta: AiModelPicker.
// Quién lo usa: NovahGenerateChat.

import { KIE_MODELS } from '@agency-smm/shared';
import { WidgetWrap, StyleGrid, StyleOption, StyleIcon, StyleLabel, PlanTag } from '../styled';

interface Props {
  confirmAiModel: (model: string) => void;
}

export function AiModelPicker({ confirmAiModel }: Props) {
  return (
    <WidgetWrap>
      <StyleGrid>
        {KIE_MODELS.map((m) => (
          <StyleOption key={m.id} $active={false} onClick={() => confirmAiModel(m.id)}>
            <StyleIcon>🤖</StyleIcon><StyleLabel>{m.name}</StyleLabel>
          </StyleOption>
        ))}
        <StyleOption $active={false} onClick={() => confirmAiModel('mix')} style={{ gridColumn: '1 / -1' }}>
          <StyleIcon>🎲</StyleIcon><StyleLabel>Mix all models</StyleLabel>
          <PlanTag>Equal split</PlanTag>
        </StyleOption>
      </StyleGrid>
    </WidgetWrap>
  );
}
